import ApiService from '@/common/api.service'
import Vue from 'vue'

const uuid = require('uuid/v4');

/*
 * Current order empty template
 */
const PREORDER = {
  id: undefined,
  customer: null,
  day: null,
  status: null,
  items: [],
  total: 0,
  taxes: null,
  synced: 0,
  list: []
}

const state = {
  order: null,
}

const getters = {

  /*
   *
   */
  order: (state) => state.order,

  /*
   *
   */
  taxes: (state) => state.order ? state.order.taxes : null,

  /*
   *
   */
  customer: (state) => state.order ? state.order.customer : null,

  /*
   * returns total amount
   */
  total: (state) => {
    let total = 0
    if(! state.order) return 0
    state.order.items.forEach(item => {
      total += item.qty * item.product.base_price // todo +modifiers
    })
    return total
  },

  /*
   * returns a preorders list
   */
  list: (state) => {
    return state.list
  }

}

const actions = {
  /*
   * Creates a new blank preorder
   * by using ORDER template. Uses JSON.parse and stringify
   * to deep clone without reactivity
   */
  createNewOrder: (context) => {
    let order = JSON.parse(JSON.stringify(PREORDER))
    order.day = context.rootState.general.day
    order.timestamp = +new Date
    context.commit('preorder/order', order, { root: true })
  },

  /*
   * Add an item to current order
   */
  addItemToOrder: (context, payload) => {
    payload.item.timestamp = +new Date // Date.now()
    context.commit('preorder/order_item_add', {item: payload.item, qty: payload.qty}, { root: true })
  },

  /*
   * Add builder item to current order as item
   */
  addBuilderItemToOrder: (context, payload) => {
    let builder = context.rootState.products.builder
    let item = builder.product
    let q = payload.qty || 1
    item.categories = builder.categories
    item.timestamp = +new Date
    context.commit('preorder/order_item_add', {item: item, qty: q}, { root: true })
  },

  /*
   * Cancel current order
   */
  cancelOrder: ({commit, dispatch, state}) => {
    dispatch('createNewOrder')
  },

  /*
   * Close and submit current order
   * Add order to orders collection
   */
  closeOrder: ({commit, dispatch, state, rootGetters}) => {
    commit('customer', rootGetters['user/info'].id)
    return new Promise((resolve, reject) => {
      ApiService.post('employee/order/save', state.order).then(result => {
        vm.$toasted.show(result.data.meta.message)
        let menu = dispatch('products/getMenus', null, {root: true})
        Promise.all([menu]).then(function() {
          resolve()
        }).catch(err => {
          console.log(err);
          reject(err)
        })
      }).catch(err => {
        console.log(err);
        vm.$toasted.show(err)
        reject()
      })
    })
  },

  /*
   * Restore existing preorder
   * If not create a new order
   */
  loadPreorder: (context, day) => {
    return new Promise((resolve, reject) => {
      ApiService.get(`employee/order/day/${day}/preorder`).then((result) => {
        let order = JSON.parse(JSON.stringify(PREORDER))
        let incoming_order = result.data.data
        order.id = incoming_order.id
        order.day = day
        order.items = incoming_order.items.data
        order.total = incoming_order.total * 1
        order.taxes = incoming_order.taxes * 1
        order.status = incoming_order.status
        order.customer = incoming_order.customer_id
        context.commit('preorder/order', order, { root: true })
        resolve(order)   
      }).catch(err => {
        context.dispatch('createNewOrder')
        console.error(err);
        resolve()
      })
    })
  },

  /*
   * Get a list of preorders
   * for current user
   */
  loadPreorders: ({commit, dispatch, state, rootGetters}) => {
    return new Promise((resolve, reject) => {
      ApiService.get(`employee/order/list/customer/${rootGetters['user/info'].id}?include=items,customer,cashier`).then((result) => {
        let preorders = result.data.data
        commit('preorder/preorders', preorders, { root: true })
        resolve(preorders)   
      }).catch(err => {
        console.error(err);
        reject()
      })
    })
  }
}

const mutations = {

  /*
   * Set current order
   * then add it to local database
   */
  ['order']: (state, order) => {
    state.order = order
  },

  /*
   * Add an item to current order
   * creates an unique id then updates local database with
   * current order's items
   */
  ['order_item_add']: (state, payload) => {
    let item = {}
    item.id = uuid()
    item.qty = payload.qty || 1
    item.product = JSON.parse(JSON.stringify(payload.item))
    state.order.items.push(item)
  },

  /*
   * Increase item quantity by one
   * then updates local database
   */
  ['order_item_increase_q']: (state, item) => {
    item.qty -= -1
  },

  /*
   * Decrease item quantity by one
   * then updates local database
   */
  ['order_item_decrease_q']: (state, item) => {
    item.qty -= 1
  },

  /*
   * Decrease item quantity by one
   * then updates local database
   */
  ['order_item_update_q']: (state, payload) => {
    payload.item.qty = payload.qty * 1
  },

  /*
   * Delete one item from current order
   * then updates local database
   */
  ['order_item_delete']: (state, item) => {
    let key = state.order.items.findIndex(product => { return product.id == item.id})
    Vue.delete(state.order.items, key)
  },

  /*
   * Add customer to current order
   * then updates local database
   */
  ['customer']: (state, customer) => {
    if(state.order) state.order.customer = customer
  },

  /*
   * Preorders list
   * 
   */
  ['preorders']: (state, preorders) => {
    state.list = preorders
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
